import React from 'react';
import CKAutocomplete from '../CKAutocomplete';
import WorkdocStore from '../../../stores/WorkdocStore'
import {connect} from 'react-redux'

class AutoSuggestionTitle extends React.Component {

  constructor(...args) {
    super(...args);

    this.state = {items:[]}
  }

  componentDidMount() {
    this.loadTitle()
  }

  loadTitle() {
    let items = []
    WorkdocStore.loadTitle((result)=>{
        result.data.forEach((item,index)=>{
            items.push({label:item.Name,value:item.Value})
        })
        this.setState({items:items})
    })
  }

  onFormChange(e) {
    this.props.onChange(e.target.value)   
  }

  onFormSelect(e) {
    this.props.onChange(e)
  }

  render() {
    const {
      formData
    } = this.props;
    let {items} = this.state
    return (
        <div>
            <CKAutocomplete
                top={'-35px'}
                items={items}
                value={formData}
                onChange={this.onFormChange.bind(this)}
                onSelect={this.onFormSelect.bind(this)}
            />
        </div>    
    )
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const _Connect = connect(
    mapStateToProps,
)(AutoSuggestionTitle);

export default _Connect;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/AutoSuggestionTitle.js